import { IApplicationState } from '../../types/redux';

export function selectResults(state: IApplicationState) {
  return state.results;
}
